import en from './texts/en.json';
import ru from './texts/ru.json';
import de from './texts/de.json';

export const defaultLocale = 'en';

const messagesByLocale = {
    en,
    ru: { ...en, ...ru },
    de: { ...en, ...de },
};

export const getMessages = (locale) => {
    return messagesByLocale[locale] || en;
};

export const locales = {
    en: 'English',
    de: 'Deutsch',
    ru: 'Русский',
};
